import { Component, computed, input } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { heroPlus } from '@ng-icons/heroicons/outline';
import { IconComponent } from '../icon/icon.component';
import { NgClass } from '@angular/common';

export type ButtonColor = 'gradientBlue' | 'warning' | 'white' | 'outlineBlue' | 'blue' | 'gray';
export type ButtonType = 'create';

@Component({
  selector: 'button[appButton]',
  standalone: true,
  imports: [IconComponent, NgClass],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  host: {
    '[class]': 'class()',
  },
  providers: [
    provideIcons({
      heroPlus,
    }),
  ],
})
export class ButtonComponent {
  color = input('gradientBlue', { transform: (value: ButtonColor | undefined) => (value ? value : 'gradientBlue') });
  buttonType = input<ButtonType>();
  noSpaces = input(false);
  class = computed(
    () =>
      `${this.classes[this.color()]} ${this.noSpaces() ? 'px-4' : 'px-6'} flex items-center justify-center font-regular rounded-full pointer disabled:opacity-50`,
  );
  classes: { [key in ButtonColor]: string } = {
    gradientBlue: 'py-3 from-blue-light to-blue-lighten text-white shadow-xl bg-gradient-to-l',
    warning: 'py-3 bg-yellow text-white shadow-xl',
    white: 'py-3 shadow-none text-blue',
    outlineBlue: 'py-[10px] border-2 border-blue text-blue',
    blue: 'py-[10px] border-2 border-blue bg-blue text-white',
    gray: 'py-[10px] bg-gray text-white',
  };

  get isCreate(): boolean {
    return this.buttonType() === 'create';
  }
}
